import { HelpTextMarkdown } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { withConsultationsText, WithConsultationsTextProps } from '@/components/consultations/withConsultationsText';

interface ConsultationsContentProps extends WithConsultationsTextProps {}

export const ConsultationsContentComponent: React.FC<ConsultationsContentProps> = ({ text }) => {
  return <HelpTextMarkdown id={'consultations'} text={text} />;
};

export const ConsultationsContent = withConsultationsText(ConsultationsContentComponent);
